import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';
import { MaterialModule } from '../material.module';

// icons
import { MatNativeDateModule } from '@angular/material/core';
import { TablerIconsModule } from 'angular-tabler-icons';
import * as TablerIcons from 'angular-tabler-icons/icons';
import { NgPipesModule } from 'ngx-pipes';
import { KendoModule } from '../kendo.module';
import { CluPuSnackbarService } from './@services/clupu-snackbar.service';
import { ConnectorWCashDeskLoyaltyLandingService } from './w-cashdesk/m-loyalty-landing/connector-m-loyalty-landing.service';
import { PublicWCashdeskMLoyaltyLandingComponent } from './w-cashdesk/m-loyalty-landing/m-loyalty-landing.component';
import { ConnectorWRemDocsESignProcessService } from './w-remdocs/m-esign-process/connector-m-esign-process.service';
import { PublicWRemDocsMESignProcessComponent } from './w-remdocs/m-esign-process/m-esign-process.component';

export const routes: Routes = [
    {
        path: '',
        children: [
            {
                path: 'public/w-cashdesk/m-loyalty-landing',
                component: PublicWCashdeskMLoyaltyLandingComponent
            }, 
            {
                path: 'public/w-remdocs/m-esign-process',
                component: PublicWRemDocsMESignProcessComponent
            }
        ],
    }
];

@NgModule({
    declarations: [PublicWCashdeskMLoyaltyLandingComponent, PublicWRemDocsMESignProcessComponent],
    providers: [ConnectorWCashDeskLoyaltyLandingService, ConnectorWRemDocsESignProcessService, CluPuSnackbarService],
    imports: [
        CommonModule,
        RouterModule.forChild(routes),
        MaterialModule, 
        MatNativeDateModule,
        KendoModule, 
        NgPipesModule,
        FormsModule, 
        ReactiveFormsModule,
        TablerIconsModule.pick(TablerIcons)
    ],
})
export class CluPublicModule {}
